import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import MobileMoneyModal from "../mobile_money_modal/Summer_Mobile_Modal";
import PaymentSuccessModal from "../paymentStatusModal/PaymentStatusModal";
import useQuery from "../../hooks/useParams";
import PageLoader from "../page_loader/PageLoader";
import OrderSummary from "../order_summary/OrderSummary ";

/* ─── INLINE STYLES (UNTOUCHED + NEW TEST BTN STYLE) ─── */
const S = {
  page: {
    background: "linear-gradient(135deg, #f8fafc 0%, #eef2f7 100%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "40px 16px 80px",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    color: "#1e293b",
  },
  pageMobile: { padding: "22px 12px 60px" },
  hero: { textAlign: "center", marginBottom: 36 },
  heroOrg: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.22em",
    textTransform: "uppercase",
    color: "#7c3aed",
    marginBottom: 6,
  },
  heroTitle: {
    fontSize: "clamp(1.6rem, 4vw, 2.4rem)",
    fontWeight: 800,
    color: "#0f172a",
    letterSpacing: "-0.03em",
    margin: 0,
  },
  heroSub: { fontSize: 14, color: "#64748b", marginTop: 8 },
  card: {
    background: "#ffffff",
    borderRadius: 20,
    boxShadow:
      "0 4px 6px -1px rgba(0,0,0,0.07), 0 20px 60px -10px rgba(0,0,0,0.10)",
    width: "100%",
    maxWidth: 860,
    overflow: "hidden",
  },
  sectionHeader: {
    background: "linear-gradient(90deg, #7c3aed 0%, #6d28d9 100%)",
    padding: "14px 28px",
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  sectionHeaderText: {
    color: "#fff",
    fontWeight: 700,
    fontSize: 13,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
  },
  sectionHeaderDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.45)",
  },
  body: { padding: "28px 28px 8px" },
  grid2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 24px" },
  field: { marginBottom: 20 },
  label: {
    display: "block",
    fontSize: 12,
    fontWeight: 600,
    color: "#475569",
    marginBottom: 6,
    letterSpacing: "0.04em",
  },
  labelError: { color: "#dc2626" },
  inputBase: {
    width: "100%",
    height: 42,
    padding: "0 14px",
    border: "1.5px solid #e2e8f0",
    borderRadius: 10,
    fontSize: 14,
    color: "#0f172a",
    background: "#f8fafc",
    outline: "none",
    transition: "border-color 0.2s, box-shadow 0.2s",
    boxSizing: "border-box",
  },
  inputError: { borderColor: "#fca5a5", background: "#fff5f5" },
  divider: { height: 1, background: "#f1f5f9", margin: "4px 0 24px" },
  menuWrap: { padding: "0 28px 24px" },
  weekTab: { display: "flex", gap: 8, marginTop: 16 },
  weekTabBtn: (active) => ({
    padding: "7px 18px",
    borderRadius: 8,
    border: "none",
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 600,
    background: active ? "#7c3aed" : "#f1f5f9",
    color: active ? "#fff" : "#64748b",
    transition: "all 0.2s",
  }),
  menuTable: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: 13,
    borderRadius: 12,
    overflow: "hidden",
    border: "1.5px solid #e2e8f0",
  },
  menuTh: {
    padding: "11px 16px",
    textAlign: "left",
    fontWeight: 700,
    fontSize: 11,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    background: "#7c3aed",
    color: "#fff",
    borderBottom: "1.5px solid #6d28d9",
  },
  menuThDay: { width: 120, background: "#6d28d9" },
  menuTr: (i) => ({
    background: i % 2 === 0 ? "#fafafe" : "#fff",
    transition: "background 0.15s",
  }),
  menuTd: {
    padding: "12px 16px",
    borderBottom: "1px solid #f1f5f9",
    verticalAlign: "middle",
  },
  menuTdDay: {
    fontWeight: 700,
    fontSize: 12,
    color: "#7c3aed",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    borderRight: "1.5px solid #e2e8f0",
  },
  menuDate: {
    fontSize: 10,
    color: "#64748b",
    fontWeight: 400,
    letterSpacing: "0.02em",
    marginTop: 2,
  },
  menuOptionWrap: { display: "flex", flexDirection: "column", gap: 6 },
  menuRadioLabel: (selected) => ({
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    padding: "9px 12px",
    borderRadius: 8,
    border: `1.5px solid ${selected ? "#7c3aed" : "#e2e8f0"}`,
    background: selected ? "#f5f3ff" : "#fff",
    cursor: "pointer",
    transition: "all 0.18s",
    fontSize: 13,
    color: "#1e293b",
    lineHeight: 1.4,
  }),
  menuRadio: {
    marginTop: 2,
    accentColor: "#7c3aed",
    flexShrink: 0,
    width: 15,
    height: 15,
  },
  menuError: { fontSize: 11, color: "#dc2626", marginTop: 4, paddingLeft: 4 },
  footer: {
    padding: "20px 28px 28px",
    borderTop: "1px solid #f1f5f9",
    display: "flex",
    justifyContent: "center",
    gap: 12,
  },
  submitBtn: {
    height: 48,
    padding: "0 48px",
    borderRadius: 12,
    border: "none",
    cursor: "pointer",
    background: "linear-gradient(135deg, #7c3aed, #6d28d9)",
    color: "#fff",
    fontSize: 15,
    fontWeight: 700,
    letterSpacing: "0.04em",
    boxShadow: "0 4px 14px rgba(124, 58, 237, 0.35)",
    transition: "transform 0.15s, box-shadow 0.15s",
  },
  /* ── Added Test button style ── */
  testBtn: {
    height: 48,
    padding: "0 32px",
    borderRadius: 12,
    border: "2px dashed #dc2626",
    cursor: "pointer",
    background: "#fff",
    color: "#dc2626",
    fontSize: 15,
    fontWeight: 700,
    letterSpacing: "0.04em",
    transition: "all 0.15s",
  },
  errText: { fontSize: 11, color: "#dc2626", marginTop: 4, display: "block" },
  radioGroup: { display: "flex", gap: 20, paddingTop: 4 },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13,
    cursor: "pointer",
    color: "#334155",
  },
  menuEmptyNotice: {
    padding: "20px 16px",
    textAlign: "center",
    borderRadius: 10,
    border: "1.5px dashed #c4b5fd",
    background: "#faf5ff",
    color: "#6d28d9",
    fontSize: 13,
    fontWeight: 500,
  },
  menuGlobalError: {
    fontSize: 12,
    color: "#dc2626",
    fontWeight: 600,
    marginTop: 10,
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
};

const WEEK_LABELS = ["Week 1", "Week 2", "Week 3", "Week 4"];

/* ─── UTILITY: parse "YYYY-MM-DD" safely without timezone shift ─── */
const parseLocalDate = (str) => {
  if (!str) return null;
  const [y, m, d] = str.split("-").map(Number);
  return new Date(y, m - 1, d);
};

/* ─── UTILITY: filter API menu items that fall inside [from, to] ─── */
const filterMenuByDateRange = (allMenuItems, periodFrom, periodTo) => {
  if (!periodFrom || !periodTo || !allMenuItems?.length) return [];
  const from = parseLocalDate(periodFrom);
  const to = parseLocalDate(periodTo);
  if (!from || !to || from > to) return [];
  return allMenuItems.filter((item) => {
    const d = parseLocalDate(item.created_date);
    return d && d >= from && d <= to;
  });
};

/* ─── UTILITY: group filtered menu items by week slot ─── */
const groupMenuByWeek = (filteredItems) => {
  if (!filteredItems?.length) return {};
  const sorted = [...filteredItems].sort(
    (a, b) => parseLocalDate(a.created_date) - parseLocalDate(b.created_date),
  );
  const weeks = {};
  let weekNum = 1;
  let dayCount = 0;
  sorted.forEach((item) => {
    if (!weeks[weekNum]) weeks[weekNum] = [];
    weeks[weekNum].push(item);
    dayCount++;
    if (dayCount === 5) {
      weekNum++;
      dayCount = 0;
    }
  });
  return weeks;
};

/* ─── UTILITY: build empty menu selections from grouped weeks ─── */
const buildEmptyMenuSelectionsFromGroups = (groupedMenu) => {
  const out = {};
  Object.keys(groupedMenu).forEach((w) => {
    out[Number(w)] = {};
    groupedMenu[w].forEach((item) => {
      out[Number(w)][item.day] = "";
    });
  });
  return out;
};

/* ─── UTILITY: build menu_selection payload array ─── */
/* ─── UTILITY: build menu_selection payload array with option codes ─── */
const buildMenuSelectionArray = (groupedMenu, menuSelections) => {
  const menu_selection = [];
  Object.keys(groupedMenu).forEach((wKey) => {
    const w = Number(wKey);
    const items = groupedMenu[w] || [];
    const selectionsForWeek = menuSelections?.[w] || {};
    items.forEach((menuItem) => {
      const opt = selectionsForWeek[menuItem.day];
      if (!menuItem.created_date || !opt) return;

      // Extract the corresponding menu option code from the API response object
      const selectedCode =
        opt === "opt1" ? menuItem["option 1 code"] : menuItem["option 2 code"];

      menu_selection.push({
        dt_meal_date: menuItem.created_date,
        vc_menu_option: selectedCode || "", // Sends the actual code string to the endpoint
      });
    });
  });
  return menu_selection;
};

/* ════════════════════════════════════════════
    SUB-COMPONENTS
════════════════════════════════════════════ */
const Field = ({ label, err, required, children }) => (
  <div style={S.field}>
    <label
      style={{
        ...S.label,
        ...(err ? S.labelError : {}),
        display: "flex",
        alignItems: "baseline",
        gap: 4,
        flexWrap: "wrap",
      }}
    >
      <span>{label}</span>
      {required && <span style={{ color: "#dc2626" }}>*</span>}
    </label>
    {children}
    {err && <span style={S.errText}>{err}</span>}
  </div>
);

const SectionHeader = ({ label }) => (
  <div style={S.sectionHeader}>
    <div style={S.sectionHeaderDot} />
    <span style={S.sectionHeaderText}>{label}</span>
  </div>
);

const MenuTable = ({
  week,
  groupedMenu,
  menuSelections,
  menuErrors,
  onMenuSelect,
}) => {
  const weekItems = groupedMenu?.[week] || [];

  if (!weekItems.length) {
    return (
      <div style={S.menuEmptyNotice}>
        No menu items available for the selected date range in this week.
      </div>
    );
  }

  return (
    <table style={S.menuTable}>
      <thead>
        <tr>
          <th style={{ ...S.menuTh, ...S.menuThDay }}>Day / Date</th>
          <th style={S.menuTh}>Option 1</th>
          <th style={S.menuTh}>Option 2</th>
        </tr>
      </thead>
      <tbody>
        {weekItems.map((item, i) => {
          const dayKey = item.day;
          const dateLabel = item.created_date
            ? parseLocalDate(item.created_date)?.toLocaleDateString("en-GB", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })
            : "";
          const opt1Label = item["option 1"] || "Option 1";
          const opt2Label = item["option 2"] || "Option 2";
          const selected = menuSelections?.[week]?.[dayKey] || "";
          const hasErr = menuErrors?.[`${week}-${dayKey}`];

          return (
            <tr key={`${week}-${dayKey}-${i}`} style={S.menuTr(i)}>
              <td style={{ ...S.menuTd, ...S.menuTdDay }}>
                {dayKey}
                {dateLabel && <div style={S.menuDate}>{dateLabel}</div>}
                {hasErr && <div style={S.menuError}>⚠ Required</div>}
              </td>
              <td style={{ ...S.menuTd, borderRight: "1px solid #f1f5f9" }}>
                <label style={S.menuRadioLabel(selected === "opt1")}>
                  <input
                    type="radio"
                    style={S.menuRadio}
                    name={`menu-w${week}-${dayKey}`}
                    value="opt1"
                    checked={selected === "opt1"}
                    onChange={() => onMenuSelect(week, dayKey, "opt1")}
                  />
                  {opt1Label}
                </label>
              </td>
              <td style={S.menuTd}>
                <label style={S.menuRadioLabel(selected === "opt2")}>
                  <input
                    type="radio"
                    style={S.menuRadio}
                    name={`menu-w${week}-${dayKey}`}
                    value="opt2"
                    checked={selected === "opt2"}
                    onChange={() => onMenuSelect(week, dayKey, "opt2")}
                  />
                  {opt2Label}
                </label>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

/* ════════════════════════════════════════════
    MAIN FORM COMPONENT
════════════════════════════════════════════ */
const SummerMultiStepForm = () => {
  const registrationOpen = true;
  const query = useQuery();
  const ref = query.get("ref");

  const [isMobile, setIsMobile] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [paymentStatusMessage, setPaymentStatusMessage] = useState("");
  const [showMobileMoneyModal, setShowMobileMoneyModal] = useState(false);
  const [momoData, setMomoData] = useState([]);
  const [schools, setSchools] = useState([]);
  const [terms, SetTerms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showAllergyDetails, setShowAllergyDetails] = useState("no");
  const [activeWeekTab, setActiveWeekTab] = useState(1);
  const [menuSelections, setMenuSelections] = useState({});
  const [menuErrors, setMenuErrors] = useState({});

  const [allMenuItems, setAllMenuItems] = useState([]);
  const [menuLoading, setMenuLoading] = useState(false);
  const [groupedMenu, setGroupedMenu] = useState({});

  const [formData, setFormData] = useState({
    studentID: "",
    studentName: "",
    studentClass: "",
    studentshool: "",
    guestStudentSchoolName: "",
    studentFoodAllegy: "None",
    studentSection: "",
    schoolTerm: "",
    periodFrom: "",
    periodTo: "",
    parentFullname: "",
    parentEmail: "",
    parentNumber: "",
    paymentType: "",
  });

  const [orderSummaryState, setOrderSummaryState] = useState({});
  const [showOrderSummary, setShowOrderSummary] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia && window.matchMedia("(max-width: 640px)");
    const apply = () => setIsMobile(Boolean(mql && mql.matches));
    apply();
    if (!mql) return;
    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", apply);
      return () => mql.removeEventListener("change", apply);
    }
    mql.addListener(apply);
    return () => mql.removeListener(apply);
  }, []);

  useEffect(() => {
    setMenuLoading(true);
    axios
      .get("https://web-production-d558.up.railway.app/api/get-menu-options")
      .then((r) => setAllMenuItems(r.data?.items || []))
      .catch((err) => console.error("Menu fetch failed:", err))
      .finally(() => setMenuLoading(false));
  }, []);

  const { periodFrom, periodTo } = formData;

  useEffect(() => {
    if (!periodFrom || !periodTo || !allMenuItems.length) {
      setGroupedMenu({});
      setMenuSelections({});
      setMenuErrors({});
      return;
    }

    const from = parseLocalDate(periodFrom);
    const to = parseLocalDate(periodTo);

    if (!from || !to || to < from) {
      setGroupedMenu({});
      setMenuSelections({});
      setMenuErrors({});
      return;
    }

    const filtered = filterMenuByDateRange(allMenuItems, periodFrom, periodTo);
    const grouped = groupMenuByWeek(filtered);
    setGroupedMenu(grouped);
    setMenuSelections(buildEmptyMenuSelectionsFromGroups(grouped));
    setMenuErrors({});
    setActiveWeekTab(1);
  }, [periodFrom, periodTo, allMenuItems]);

  useEffect(() => {
    setGroupedMenu({});
    setMenuSelections({});
    setMenuErrors({});
    setActiveWeekTab(1);
    setFormData((prev) => ({ ...prev, periodFrom: "", periodTo: "" }));
  }, [formData.schoolTerm]);

  const handleRadioChange = (value) => {
    setShowAllergyDetails(value);
    setFormData({
      ...formData,
      studentFoodAllegy: value === "yes" ? "" : "None",
    });
    if (value !== "yes") setErrors({ ...errors, studentFoodAllegy: "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = { ...prev, [name]: value };
      setErrors((oldErrors) => ({ ...oldErrors, [name]: "" }));

      // Automatically provide the maximum date range as a helpful starting default
      if (name === "periodFrom" && value) {
        const selectedTermObj = terms.find(
          (_, i) => i.toString() === prev.schoolTerm.toString(),
        );
        if (selectedTermObj) {
          const termText = selectedTermObj.term.toUpperCase();
          let requiredWeekdays = 0;

          if (termText.includes("1 WEEK")) requiredWeekdays = 5;
          else if (termText.includes("2 WEEKS")) requiredWeekdays = 10;
          else if (termText.includes("3 WEEKS")) requiredWeekdays = 15;
          else if (termText.includes("4 WEEKS")) requiredWeekdays = 20;

          if (requiredWeekdays > 0) {
            updated.periodTo = calculateWeekdayEnd(value, requiredWeekdays);
            setErrors((oldErrors) => ({
              ...oldErrors,
              periodFrom: "",
              periodTo: "",
            }));
          }
        }
      }

      return updated;
    });
  };

  const handleSchoolChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    if (!value) {
      SetTerms([]);
      return;
    }
    const selected = schools.find((_, i) => i.toString() === value);
    if (selected) {
      fetch(
        `https://web-production-d558.up.railway.app/api/get-school-term?ch_price_type=${selected.ch_price_type}`,
      )
        .then((r) => r.json())
        .then((d) => SetTerms(d.items))
        .catch(console.error);
    }
  };

  const handleMenuSelect = (week, day, option) => {
    setMenuSelections((prev) => ({
      ...prev,
      [week]: { ...prev[week], [day]: option },
    }));
    setMenuErrors((prev) => ({ ...prev, [`${week}-${day}`]: false }));
  };

  const termWeekCount = Object.keys(groupedMenu).length;
  const termIdx = parseInt(formData.schoolTerm, 10);
  const termSelected = !Number.isNaN(termIdx) && formData.schoolTerm !== "";
  /* ─── UTILITY: Count weekdays (Mon-Fri) between two dates inclusive ─── */
  const countWeekdaysInRange = (startDateStr, endDateStr) => {
    if (!startDateStr || !endDateStr) return 0;
    let start = parseLocalDate(startDateStr);
    let end = parseLocalDate(endDateStr);
    if (!start || !end || start > end) return 0;

    let count = 0;
    let current = new Date(start.getTime());
    while (current <= end) {
      const dayOfWeek = current.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        // 0 = Sunday, 6 = Saturday
        count++;
      }
      current.setDate(current.getDate() + 1);
    }
    return count;
  };
  /* ─── UTILITY: Find the end date matching exactly N weekdays ahead ─── */
  const calculateWeekdayEnd = (startDateStr, totalWeekdays) => {
    if (!startDateStr || !totalWeekdays) return "";
    let current = parseLocalDate(startDateStr);
    if (!current) return "";

    let weekdaysFound = 0;

    // If the starting day itself is a weekday, count it as day 1
    const initialDay = current.getDay();
    if (initialDay !== 0 && initialDay !== 6) {
      weekdaysFound = 1;
    }

    // Loop forward day by day until we satisfy the requested weekday amount
    while (weekdaysFound < totalWeekdays) {
      current.setDate(current.getDate() + 1);
      const dayOfWeek = current.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        // Skip Sat (6) and Sun (0)
        weekdaysFound++;
      }
    }

    // Format back cleanly into standard HTML input YYYY-MM-DD format
    const y = current.getFullYear();
    const m = String(current.getMonth() + 1).padStart(2, "0");
    const d = String(current.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };
  const validateForm = () => {
    if (!registrationOpen) {
      alert("Sorry registration is over");
      return false;
    }
    const e = {};

    if (!formData.studentName.trim())
      e.studentName = "Student name is required.";
    if (!formData.studentClass.trim())
      e.studentClass = "Student class is required.";
    if (!formData.studentshool.toString().trim())
      e.studentshool = "Select School";
    if (!formData.guestStudentSchoolName.trim())
      e.guestStudentSchoolName = "Guest student school name is required.";
    if (!formData.studentSection.trim())
      e.studentSection = "Select academic section";
    if (!formData.schoolTerm.toString().trim()) e.schoolTerm = "Select a term";
    if (!formData.parentFullname.trim())
      e.parentFullname = "Parent name is required";
    if (!formData.parentEmail.trim())
      e.parentEmail = "Parent Email is required";
    if (!formData.parentNumber.trim()) {
      e.parentNumber = "Parent number is required";
    } else if (formData.parentNumber.length !== 10) {
      e.parentNumber = "Enter a valid 10-digit number";
    }
    if (!formData.paymentType.trim()) e.paymentType = "Select payment type";
    if (showAllergyDetails === "yes" && !formData.studentFoodAllegy.trim())
      e.studentFoodAllegy = "Enter an allergy";

    if (!formData.periodFrom.trim()) {
      e.periodFrom = "Select period start date";
    }
    if (!formData.periodTo.trim()) {
      e.periodTo = "Select period end date";
    }

    if (formData.periodFrom && formData.periodTo) {
      const from = parseLocalDate(formData.periodFrom);
      const to = parseLocalDate(formData.periodTo);

      if (to < from) {
        e.periodTo = "End date must be after start date";
      } else {
        const selectedTermObj = terms.find(
          (_, i) => i.toString() === formData.schoolTerm.toString(),
        );

        if (selectedTermObj) {
          const termText = selectedTermObj.term.toUpperCase();
          let maxAllowedDays = 0;

          if (termText.includes("1 WEEK")) maxAllowedDays = 5;
          else if (termText.includes("2 WEEKS")) maxAllowedDays = 10;
          else if (termText.includes("3 WEEKS")) maxAllowedDays = 15;
          else if (termText.includes("4 WEEKS")) maxAllowedDays = 20;

          if (maxAllowedDays > 0) {
            const actualWeekdays = countWeekdaysInRange(
              formData.periodFrom,
              formData.periodTo,
            );

            if (actualWeekdays > maxAllowedDays) {
              e.periodTo = `You can choose a maximum of ${maxAllowedDays} weekdays for this option.`;
            }
          }
        }
      }
    }

    if (!termWeekCount) {
      if (formData.periodFrom && formData.periodTo && !e.periodTo) {
        e.menu =
          "No menu items found for the selected date range. Please choose a valid period.";
      }
    } else {
      const mErr = {};
      let menuValid = true;
      Object.keys(groupedMenu).forEach((wKey) => {
        const w = Number(wKey);
        const items = groupedMenu[w] || [];
        items.forEach((menuItem) => {
          if (!menuSelections?.[w]?.[menuItem.day]) {
            mErr[`${w}-${menuItem.day}`] = true;
            menuValid = false;
          }
        });
      });
      if (!menuValid) {
        setMenuErrors(mErr);
        e.menu = "Please select a menu option for every day shown.";
      }
    }

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const allowedDateSet = useMemo(
    () => new Set(allMenuItems.map((item) => item.created_date)),
    [allMenuItems],
  );
  const menuDatesSorted = useMemo(
    () => [...allowedDateSet].sort(),
    [allowedDateSet],
  );
  const menuMinDate = menuDatesSorted[0] || "";
  const menuMaxDate = menuDatesSorted[menuDatesSorted.length - 1] || "";

  /* ════════════════════════════════════════════
      NEW: HANDLE TEST SUBMIT (Bypasses Gateways)
  ════════════════════════════════════════════ */
  // const handleTestSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateForm()) return;
  //   setLoading(true);

  //   const selectedSchool = schools.find(
  //     (_, i) => i.toString() === formData.studentshool.toString(),
  //   );
  //   const selectedTerm = terms.find(
  //     (_, i) => i.toString() === formData.schoolTerm.toString(),
  //   );

  //   if (!selectedSchool || !selectedTerm) {
  //     alert("Verification failed. Please re-select school/term.");
  //     setLoading(false);
  //     return;
  //   }

  //   const menu_selection = buildMenuSelectionArray(groupedMenu, menuSelections);

  //   const registration_data = {
  //     studentID: formData.studentID,
  //     studentName: formData.studentName,
  //     studentClass: formData.studentClass,
  //     studentshool: selectedSchool.school,
  //     guestStudentSchoolName: formData.guestStudentSchoolName,
  //     studentFoodAllegy:
  //       showAllergyDetails === "yes" ? formData.studentFoodAllegy : "None",
  //     studentSection: formData.studentSection,
  //     schoolTerm: selectedTerm.term,
  //     parentFullname: formData.parentFullname,
  //     parentEmail: formData.parentEmail,
  //     parentNumber: formData.parentNumber,
  //     paymentType: "TEST_BYPASS",
  //     SCHOOLCODE: selectedSchool.nu_customer_code,
  //     vc_comp_code: selectedSchool.vc_comp_code,
  //     vc_item_code: selectedTerm.vc_item_code,
  //     dt_period_from: formData.periodFrom,
  //     dt_period_to: formData.periodTo,
  //     menuSelections,
  //     groupedMenuKeys: Object.fromEntries(
  //       Object.entries(groupedMenu).map(([w, items]) => [
  //         w,
  //         items.map((i) => ({ day: i.day, created_date: i.created_date })),
  //       ]),
  //     ),
  //   };

  //   // Construct dummy test status for the transaction logs
  //   const payment_data = {
  //     payment_amount: String(selectedTerm.nu_price || 0),
  //     date_of_payment: new Date().toISOString(),
  //     paymentRef: `TEST-${Date.now()}`,
  //     paymentStatus: "SUCCESS",
  //     payment_type: "TEST_BYPASS",
  //   };

  //   try {
  //     // Sends direct data array straight into your database registration endpoint
  //     await axios.post(
  //       "https://web-production-d558.up.railway.app/api/summer-camp/registration",
  //       {
  //         registration_data,
  //         payment_data,
  //         menu_selection,
  //         orderRef: payment_data.paymentRef,
  //       },
  //       { timeout: 60000 },
  //     );

  //     setPaymentStatus("SUCCESS");
  //     setPaymentStatusMessage(
  //       "Test submission completed successfully! (Payment skipped)",
  //     );
  //   } catch (err) {
  //     alert("Test payload submission failed.");
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  /* ── Standard Production Submit ── */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);

    const selectedSchool = schools.find(
      (_, i) => i.toString() === formData.studentshool.toString(),
    );
    const selectedTerm = terms.find(
      (_, i) => i.toString() === formData.schoolTerm.toString(),
    );

    if (!selectedSchool || !selectedTerm) {
      alert(
        "Selected school or term configuration could not be verified. Please re-select and try again.",
      );
      setLoading(false);
      return;
    }

    const menu_selection = buildMenuSelectionArray(groupedMenu, menuSelections);

    const registration_data = {
      studentID: formData.studentID,
      studentName: formData.studentName,
      studentClass: formData.studentClass,
      studentshool: selectedSchool.school,
      guestStudentSchoolName: formData.guestStudentSchoolName,
      studentFoodAllegy:
        showAllergyDetails === "yes" ? formData.studentFoodAllegy : "None",
      studentSection: formData.studentSection,
      schoolTerm: selectedTerm.term,
      parentFullname: formData.parentFullname,
      parentEmail: formData.parentEmail,
      parentNumber: formData.parentNumber,
      paymentType: formData.paymentType,
      SCHOOLCODE: selectedSchool.nu_customer_code,
      vc_comp_code: selectedSchool.vc_comp_code,
      vc_item_code: selectedTerm.vc_item_code,
      dt_period_from: formData.periodFrom,
      dt_period_to: formData.periodTo,
      menuSelections,
      groupedMenuKeys: Object.fromEntries(
        Object.entries(groupedMenu).map(([w, items]) => [
          w,
          items.map((i) => ({ day: i.day, created_date: i.created_date })),
        ]),
      ),
    };
// Log the unified structure cleanly to console right before gateway routing
    console.log("=== PENDING SUBMISSION DATA STRUCTURE ===");
    console.log(JSON.stringify({ registration_data, menu_selection }, null, 2));
    
    try {

      if (formData.paymentType === "Card Payment") {
        console.log("=== Card Payment Selected by shubhamhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh===");


        const response = await axios.post(
          "https://web-production-d558.up.railway.app/api/authorize-payment",
          { registrationData: registration_data,menu_selection,selectedSchool, selectedTerm },
          { timeout: 60000 },
        );
         console.log("=== Shubham  ===");
        console.log(response,"Response of payment");

        if (response.status === 200 && response.data.order_reference) {
          const orderRef = response.data.order_reference;
          const termAmount = selectedTerm.nu_price;
          const bankCharges = selectedTerm.bank;
          const totalAmount = termAmount + bankCharges;

          const payment_data = {
            payment_amount: totalAmount,
            date_of_payment: new Date().toISOString(),
            paymentRef: orderRef,
            paymentStatus: "PENDING",
            payment_type: "CARD",
          };

          await axios.post(
            // "https://web-production-d558.up.railway.app/api/summer-camp/registration",
                        "https://web-production-d558.up.railway.app/api/temp-summer-camp/registration-records",
            { registration_data, payment_data, menu_selection, orderRef },
            { timeout: 500000 },
          );

          localStorage.setItem(
            orderRef,
            JSON.stringify({
              ...registration_data,
              menu_selection,
              formType: "summer-camp",
            }),
          );

          setOrderSummaryState({
            paymentType: "Card Payment",
            payment_link: response.data.pay_url,
            studentName: formData.studentName,
            selectedTerm: selectedTerm.term,
            termAmount,
            bankCharges,
            totalAmount,
          });
          setShowOrderSummary(true);
        }
      } else {
        const response = await axios.get(
          "https://web-production-d558.up.railway.app/api/mobile-payment-option",
        );
        if (response.status === 200) {
          const termAmount = selectedTerm.nu_price;
          const momoCharges = selectedTerm.momo;
          const totalAmount = termAmount + momoCharges;

          setOrderSummaryState({
            payment_link: "",
            studentName: formData.studentName,
            selectedTerm: selectedTerm.term,
            termAmount,
            bankCharges: momoCharges,
            totalAmount,
            _registration_data: registration_data,
            _menu_selection: menu_selection,
            _totalAmount: totalAmount,
          });
          setShowOrderSummary(true);
          setMomoData(response.data);
        }
      }
    } catch (err) {
      alert("Something went wrong. Please reload and try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleMomoPaymentConfirmed = async ({
    paymentRef,
    paymentStatus,
    paymentAmount,
    dateOfPayment,
  }) => {
    const { _registration_data, _menu_selection } = orderSummaryState;
    if (!_registration_data || !_menu_selection) {
      console.error("MoMo callback data missing.");
      return;
    }
    const payment_data = {
      payment_amount: String(paymentAmount ?? ""),
      date_of_payment: dateOfPayment ?? new Date().toISOString(),
      paymentRef: paymentRef ?? "",
      paymentStatus: paymentStatus ?? "SUCCESS",
      payment_type: "MTN MONEY",
    };
    try {
      await axios.post("https://web-production-d558.up.railway.app/api/summer-camp/registration", {
        registration_data: _registration_data,
        payment_data,
        menu_selection: _menu_selection,
      });
    } catch (err) {
      console.error("MoMo registration POST failed:", err);
    }
  };

  useEffect(() => {
    if (!ref) return;
    setPageLoading(true);
    const processed = JSON.parse(localStorage.getItem("processedRefs") || "[]");
    if (processed.includes(ref)) {
      setPaymentStatus("SUCCESS");
      setPaymentStatusMessage("Payment already made");
      setPageLoading(false);
      return;
    }
    axios
      .get(`https://web-production-d558.up.railway.app/api/payment-outcome?ref=${ref}`)
      .then(async (r) => {
        const data = r.data;
        const regRaw = localStorage.getItem(ref);
        if (regRaw && data && data.order_status === "PURCHASED") {
          try {
            const parsed = JSON.parse(regRaw);
            const menu_selection =
              Array.isArray(parsed.menu_selection) && parsed.menu_selection.length
                ? parsed.menu_selection
                : buildMenuSelectionArray(
                    Object.fromEntries(
                      Object.entries(parsed.groupedMenuKeys || {}).map(([w, items]) => [
                        Number(w),
                        items,
                      ]),
                    ),
                    parsed.menuSelections || {},
                  );

            const {
              menuSelections: _m,
              groupedMenuKeys: _g,
              menu_selection: _ms,
              formType: _f,
              ...registration_data
            } = parsed;

            const payment = data.outResponse?._embedded?.payment?.[0];
            const payment_data = {
              payment_amount: String(
                data.outResponse?.amount?.value != null
                  ? data.outResponse.amount.value / 100
                  : "",
              ),
              date_of_payment:
                payment?.updateDateTime ?? new Date().toISOString(),
              paymentRef: ref,
              paymentStatus: data.order_status ?? payment?.state ?? "SUCCESS",
              payment_type: "CARD",
            };

            console.log("=== FINAL REGISTRATION DATA STRUCTURE ===");
            console.log(
              JSON.stringify({ registration_data, payment_data, menu_selection }, null, 2),
            );
            await axios.post(
              "https://web-production-d558.up.railway.app/api/summer-camp/registration",
              { registration_data, payment_data, menu_selection },
            );
          } catch (err) {
            console.error("Card final registration POST failed:", err);
          }
        }
        setPaymentStatus(data.order_status);
        processed.push(ref);
        localStorage.setItem("processedRefs", JSON.stringify(processed));
      })
      .catch(console.error)
      .finally(() => setPageLoading(false));
  }, [ref]);

  useEffect(() => {
    axios
      .get("https://web-production-d558.up.railway.app/api/get-school-data")
      .then((r) => setSchools(r.data.items))
      .catch(console.error);
  }, []);

  useEffect(() => {
    if (!schools.length || formData.studentshool) return;
    setFormData((prev) => ({ ...prev, studentshool: 0 }));
    fetch(
      `https://web-production-d558.up.railway.app/api/get-summer-school-term?ch_price_type=${schools[0].ch_price_type}`,
    )
      .then((r) => r.json())
      .then((d) => SetTerms(d.items))
      .catch(console.error);
  }, [schools, formData.studentshool]);

  const inp = (name, type = "text", extra = {}) => ({
    name,
    type,
    value: formData[name],
    onChange: handleChange,
    style: { ...S.inputBase, ...(errors[name] ? S.inputError : {}), ...extra },
    onFocus: (e) => {
      e.target.style.borderColor = "#7c3aed";
      e.target.style.boxShadow = "0 0 0 3px rgba(124,58,237,0.12)";
    },
    onBlur: (e) => {
      e.target.style.borderColor = errors[name] ? "#fca5a5" : "#e2e8f0";
      e.target.style.boxShadow = "none";
    },
  });

  const sel = (name, onChange) => ({
    name,
    value: formData[name],
    onChange: onChange || handleChange,
    style: {
      ...S.inputBase,
      ...(errors[name] ? S.inputError : {}),
      cursor: "pointer",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%237c3aed' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 14px center",
      paddingRight: 36,
    },
  });

  return (
    <div
      style={{ ...S.page, ...(isMobile ? S.pageMobile : {}) }}
      id="summerCampRegistration"
    >
      {showMobileMoneyModal && momoData && (
        <MobileMoneyModal
          show={showMobileMoneyModal}
          onClose={() => setShowMobileMoneyModal(false)}
          data={momoData}
          registrationData={formData}
          selectedSchool={schools.find(
            (_, i) => i.toString() === formData.studentshool?.toString(),
          )}
          selectedTerm={terms.find(
            (_, i) => i.toString() === formData.schoolTerm?.toString(),
          )}
          setPaymentStatus={setPaymentStatus}
          menu_selection={orderSummaryState._menu_selection}
          onPaymentConfirmed={handleMomoPaymentConfirmed}
        />
      )}

      <PaymentSuccessModal
        isOpen={paymentStatus}
        onClose={setPaymentStatus}
        status={paymentStatus}
        message={paymentStatusMessage}
      />

      <OrderSummary
        show={showOrderSummary}
        setShowOrderSummary={setShowOrderSummary}
        data={orderSummaryState}
        setShowMobileMoneyModal={setShowMobileMoneyModal}
        paymentType={formData.paymentType}
      />

      {pageLoading && <PageLoader show={pageLoading} />}

      <div style={S.hero}>
        <div style={S.heroOrg}>Atlantic School</div>
        <h1 style={S.heroTitle}>Summer Camp Meal Registration</h1>
        <p style={S.heroSub}>
          Complete the form below to register your child for the summer camp
          meal programme.
        </p>
      </div>

      <div className="summerRegistrationContainer">
        <div style={S.card}>
          <form onSubmit={handleSubmit}>
            <SectionHeader label="Student Details" />
            <div
              style={{
                ...S.body,
                ...(isMobile ? { padding: "18px 12px 8px" } : {}),
              }}
            >
              <div
                style={{
                  ...S.grid2,
                  gridTemplateColumns: isMobile
                    ? "1fr"
                    : S.grid2.gridTemplateColumns,
                  gap: isMobile ? 0 : "0 24px",
                }}
              >
                <Field
                  label="Hosting School"
                  err={errors.studentshool}
                  required
                >
                  <select {...sel("studentshool", handleSchoolChange)}>
                    <option value="">Select School</option>
                    {schools.map((s, i) => (
                      <option key={i} value={i}>
                        {" "}
                        {s.school}{" "}
                      </option>
                    ))}
                  </select>
                </Field>

                <Field
                  label="Guest Student School name"
                  err={errors.guestStudentSchoolName}
                  required
                >
                  <input
                    {...inp("guestStudentSchoolName")}
                    placeholder="School name"
                  />
                </Field>

                <Field label="Student Name" err={errors.studentName} required>
                  <input {...inp("studentName")} placeholder="Full name" />
                </Field>
                <Field
                  label="Academic Section"
                  err={errors.studentSection}
                  required
                >
                  <select {...sel("studentSection")}>
                    <option value="">Select Section</option>
                    <option value="Infant">Infant</option>
                    <option value="Junior">Junior</option>
                    <option value="Secondary">Secondary</option>
                  </select>
                </Field>
                <Field label="Class" err={errors.studentClass} required>
                  <input
                    {...inp("studentClass")}
                    placeholder="e.g. 1 Rose"
                    disabled={!formData.studentSection}
                  />
                </Field>
                <Field label="Term" err={errors.schoolTerm} required>
                  <select {...sel("schoolTerm")}>
                    <option value="">Select Term</option>
                    {terms.map((t, i) => (
                      <option key={i} value={i}>
                        {t.term}
                      </option>
                    ))}
                  </select>
                </Field>
                <Field label="Student ID" err={errors.studentID}>
                  <input {...inp("studentID")} placeholder="e.g. ATL-00123" />
                </Field>
              </div>

              <Field
                label="Any food allergy / dietary restriction?"
                err={errors.studentFoodAllegy}
              >
                <div style={S.radioGroup}>
                  {["yes", "no"].map((v) => (
                    <label key={v} style={S.radioLabel}>
                      <input
                        type="radio"
                        name="showAllergyDetails"
                        value={v}
                        checked={showAllergyDetails === v}
                        onChange={() => handleRadioChange(v)}
                        style={{ accentColor: "#7c3aed" }}
                      />
                      {v.charAt(0).toUpperCase() + v.slice(1)}
                    </label>
                  ))}
                </div>
                {showAllergyDetails === "yes" && (
                  <input
                    {...inp("studentFoodAllegy")}
                    placeholder="Describe allergy or restriction"
                    style={{
                      ...S.inputBase,
                      marginTop: 10,
                      ...(errors.studentFoodAllegy ? S.inputError : {}),
                    }}
                  />
                )}
              </Field>
            </div>

            {termSelected && (
              <div style={{ marginTop: 8 }}>
                <SectionHeader label="Camp Period" />
                <div
                  style={{
                    ...S.body,
                    ...(isMobile ? { padding: "18px 12px 8px" } : {}),
                  }}
                >
                  <div
                    style={{
                      ...S.grid2,
                      gridTemplateColumns: isMobile
                        ? "1fr"
                        : S.grid2.gridTemplateColumns,
                      gap: isMobile ? 0 : "0 24px",
                    }}
                  >
                    <Field label="Period From" err={errors.periodFrom} required>
                      <input
                        {...inp("periodFrom", "date")}
                        min={menuMinDate}
                        max={menuMaxDate}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val && !allowedDateSet.has(val)) {
                            setErrors((prev) => ({
                              ...prev,
                              periodFrom:
                                "This date has no menu items. Please pick a date from the available menu.",
                            }));
                            setFormData((prev) => ({
                              ...prev,
                              periodFrom: val,
                            }));
                          } else {
                            handleChange(e);
                          }
                        }}
                      />
                    </Field>
                    <Field label="Period To" err={errors.periodTo} required>
                      <input
                        {...inp("periodTo", "date")}
                        min={formData.periodFrom || menuMinDate}
                        // 🔒 Locks the calendar UI dropdown from going past the calculated max date
                        max={
                          formData.periodFrom &&
                          terms.find(
                            (_, i) =>
                              i.toString() === formData.schoolTerm.toString(),
                          )
                            ? calculateWeekdayEnd(
                                formData.periodFrom,
                                terms
                                  .find(
                                    (_, i) =>
                                      i.toString() ===
                                      formData.schoolTerm.toString(),
                                  )
                                  .term.toUpperCase()
                                  .includes("1 WEEK")
                                  ? 5
                                  : terms
                                        .find(
                                          (_, i) =>
                                            i.toString() ===
                                            formData.schoolTerm.toString(),
                                        )
                                        .term.toUpperCase()
                                        .includes("2 WEEKS")
                                    ? 10
                                    : terms
                                          .find(
                                            (_, i) =>
                                              i.toString() ===
                                              formData.schoolTerm.toString(),
                                          )
                                          .term.toUpperCase()
                                          .includes("3 WEEKS")
                                      ? 15
                                      : 20,
                              )
                            : menuMaxDate
                        }
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val && !allowedDateSet.has(val)) {
                            setErrors((prev) => ({
                              ...prev,
                              periodTo:
                                "This date has no menu items. Please pick a date from the available menu.",
                            }));
                            setFormData((prev) => ({ ...prev, periodTo: val }));
                          } else {
                            handleChange(e);
                          }
                        }} 
                        disabled
                      />
                    </Field>
                  </div>
                  {termSelected && !formData.periodFrom && (
                    <p
                      style={{
                        fontSize: 12,
                        color: "#7c3aed",
                        marginTop: -8,
                        marginBottom: 12,
                      }}
                    >
                      ℹ Select your camp period — only days with available menu
                      items will be shown below.
                    </p>
                  )}
                </div>
              </div>
            )}

            {termSelected && formData.periodFrom && formData.periodTo && (
              <div style={{ marginTop: 8 }}>
                <SectionHeader
                  label={
                    menuLoading
                      ? "Menu Selection — Loading…"
                      : termWeekCount > 0
                        ? `Menu Selection — ${termWeekCount} ${termWeekCount === 1 ? "Week" : "Weeks"} Available`
                        : "Menu Selection — No items found"
                  }
                />
                <div style={S.menuWrap}>
                  {menuLoading ? (
                    <div
                      style={{
                        textAlign: "center",
                        padding: 24,
                        color: "#7c3aed",
                      }}
                    >
                      Loading menu…
                    </div>
                  ) : termWeekCount === 0 ? (
                    <div style={S.menuEmptyNotice}>
                      ⚠ No menu items are available for{" "}
                      <strong>{formData.periodFrom}</strong> →{" "}
                      <strong>{formData.periodTo}</strong>.
                    </div>
                  ) : (
                    <>
                      <MenuTable
                        week={activeWeekTab}
                        groupedMenu={groupedMenu}
                        menuSelections={menuSelections}
                        menuErrors={menuErrors}
                        onMenuSelect={handleMenuSelect}
                      />
                      {errors.menu && (
                        <div style={S.menuGlobalError}>⚠ {errors.menu}</div>
                      )}
                      {termWeekCount > 1 && (
                        <div style={S.weekTab}>
                          {Object.keys(groupedMenu).map((wKey) => {
                            const w = Number(wKey);
                            return (
                              <button
                                key={w}
                                type="button"
                                style={S.weekTabBtn(activeWeekTab === w)}
                                onClick={() => setActiveWeekTab(w)}
                              >
                                {WEEK_LABELS[w - 1] || `Week ${w}`}
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}

            <div style={{ marginTop: 8 }}>
              <SectionHeader label="Parent / Guardian Details" />
              <div
                style={{
                  ...S.body,
                  ...(isMobile ? { padding: "18px 12px 8px" } : {}),
                }}
              >
                <div
                  style={{
                    ...S.grid2,
                    gridTemplateColumns: isMobile
                      ? "1fr"
                      : S.grid2.gridTemplateColumns,
                    gap: isMobile ? 0 : "0 24px",
                  }}
                >
                  <Field
                    label="Parent Full Name"
                    err={errors.parentFullname}
                    required
                  >
                    <input {...inp("parentFullname")} placeholder="Full name" />
                  </Field>
                  <Field
                    label="Email Address"
                    err={errors.parentEmail}
                    required
                  >
                    <input
                      {...inp("parentEmail")}
                      type="email"
                      placeholder="example@mail.com"
                    />
                  </Field>
                  <Field
                    label="Phone Number"
                    err={errors.parentNumber}
                    required
                  >
                    <input
                      {...inp("parentNumber", "text")}
                      placeholder="e.g. 054XXXXXXX"
                      inputMode="numeric"
                    />
                  </Field>
                  <Field
                    label="Select Payment Method"
                    err={errors.paymentType}
                    required
                  >
                    <select {...sel("paymentType")}>
                      <option value="">Select Method</option>
                      <option value="Card Payment">Card Payment</option>
                      <option value="Mobile Money">Mobile Money</option>
                    </select>
                  </Field>
                </div>
              </div>
            </div>

            {/* ── Footer with added Test Button ── */}
            <div style={S.footer}>
              <button type="submit" style={S.submitBtn} disabled={loading}>
                {loading ? "Processing…" : "Proceed to Summary"}
              </button>
              
              {/* <button
                type="button"
                style={S.testBtn}
                onClick={handleTestSubmit}
                disabled={loading}
              >
                {loading ? "Testing…" : "Test Submit (No Payment)"}
              </button> */}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SummerMultiStepForm;
